import styled, { css, keyframes } from "styled-components";

const FONT_STACK = `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif`;

export const ButtonFormStyled = styled.button`
  width: 87%;
  padding: 0.85rem 1rem;
  margin: 10px;
  border: none;
  border-radius: 8px;
  font-family: ${FONT_STACK};
  font-weight: 600;
  font-size: 0.82rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: white;
  background: linear-gradient(
    180deg,
    var(--violetaPastelOscuro) 0%,
    var(--violetaOscuro) 100%
  );
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(76, 4, 140, 0.25);
  transition:
    background 0.15s ease,
    box-shadow 0.15s ease,
    transform 0.08s ease;
  -webkit-font-smoothing: antialiased;

  &:hover {
    background: linear-gradient(
      180deg,
      var(--violeta) 0%,
      var(--violetaPastelOscuro) 100%
    );
    box-shadow: 0 4px 14px rgba(76, 4, 140, 0.38);
  }

  &:active {
    transform: scale(0.98);
  }

  &:focus-visible {
    outline: none;
    box-shadow:
      0 2px 8px rgba(76, 4, 140, 0.25),
      0 0 0 3px rgba(203, 182, 219, 0.45);
  }

  &:disabled {
    background: linear-gradient(180deg, #b0b0b0 0%, #909090 100%);
    color: white;
    cursor: not-allowed;
    box-shadow: none;
  }

  @media (max-width: 800px) {
    width: 75%;
    padding: 0.85rem;
    font-size: 0.85rem;
  }

  /* Barra de progreso dentro del botón (opcional, prop $progreso). */
  ${({ $progreso }) => $progreso && progresoCss}
`;

const VERDE = "#1e9e5a";
const VERDE_OSCURO = "#157a44";

// No sabemos cuánto va a tardar Iptel: la barra avanza rápido al principio y se
// va frenando cerca del 90%. El 100% lo pone la confirmación real.
const llenar = keyframes`
  from { width: 0%; }
  to   { width: 90%; }
`;

const progresoCss = css`
  position: relative;
  overflow: hidden;
  isolation: isolate;

  /* Mientras carga, el botón conserva el violeta (no el gris de deshabilitado). */
  &:disabled {
    background: linear-gradient(
      180deg,
      var(--violetaPastelOscuro) 0%,
      var(--violetaOscuro) 100%
    );
    box-shadow: 0 2px 8px rgba(76, 4, 140, 0.25);
    cursor: progress;
  }

  &::before {
    content: "";
    position: absolute;
    inset: 0 auto 0 0;
    z-index: -1;
    background: linear-gradient(180deg, ${VERDE} 0%, ${VERDE_OSCURO} 100%);
    width: 0%;
  }

  ${({ $progreso }) =>
    $progreso === "enviando" &&
    css`
      &::before {
        animation: ${llenar} 12s cubic-bezier(0.1, 0.75, 0.25, 1) forwards;
      }
    `}

  ${({ $progreso }) =>
    $progreso === "ok" &&
    css`
      &:disabled {
        background: linear-gradient(180deg, ${VERDE} 0%, ${VERDE_OSCURO} 100%);
        box-shadow: 0 2px 10px rgba(30, 158, 90, 0.4);
        cursor: default;
      }
      &::before {
        width: 100%;
        transition: width 0.35s ease-out;
      }
    `}

  /* Sin animaciones si el usuario las tiene desactivadas en el sistema. */
  @media (prefers-reduced-motion: reduce) {
    &::before {
      animation: none;
      transition: none;
    }
  }
`;
